import { useLocation } from 'react-router-dom';
import queryString from 'query-string-for-all';
import qs from 'qs';

export function useGetFilterFromLocation<TFilter = Record<string, unknown>>(
  defaultFilter: Partial<TFilter> = {},
  storedFiltersKey?: string
): Partial<TFilter> {
  const location = useLocation();

  const query =
    location.search.length > 1 ? qs.parse(location.search.slice(1)) : {};

  const storedFilters = storedFiltersKey
    ? JSON.parse(localStorage.getItem(storedFiltersKey))
    : {};

  return {
    ...defaultFilter,
    ...query,
    ...storedFilters,
  };
}

export function useQueryString<
  TFilter = Record<string, unknown>
>(): Partial<TFilter> {
  const location = useLocation();

  const query = queryString.parse(location.search, {
    parseBooleans: true,
    parseNumbers: true,
    arrayFormat: 'bracket',
  }) as unknown as Partial<TFilter>;

  return {
    ...query,
  };
}
